import { render, staticRenderFns } from "./DarkMatterDimensionRow.vue?vue&type=template&id=0f385116"
import script from "./DarkMatterDimensionRow.vue?vue&type=script&lang=js"
export * from "./DarkMatterDimensionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports